var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
const SvgCheck28 = props => /*#__PURE__*/React.createElement("svg", _extends({
  xmlns: "http://www.w3.org/2000/svg",
  width: 28,
  height: 28,
  fill: "none"
}, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
  fill: "currentColor",
  fillRule: "evenodd",
  d: "M24.807 4.105a.5.5 0 0 1 .088.702l-14 18a.5.5 0 0 1-.749.047l-6-6a.5.5 0 1 1 .708-.707l5.6 5.599L24.104 4.193a.5.5 0 0 1 .702-.088Z",
  clipRule: "evenodd"
})));
export { SvgCheck28 as ReactComponent };
export default __webpack_public_path__ + "3fba1cd9ad3d2a2b30419a2f5ea61682.svg";